import moment from "moment/moment"

export const getCurrentTime = () => moment().format('YYYY-MM-DD HH')